<ng-template #modal let-modal>
  <div class="modal-header">
    <h5 class="q-c-main q-bold">Dupliquation du cursus</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-modal p-0">

      <div class="row ml-3 d-flex">
        <div class="mr-3">
          <div class="q-c-main mb-2">Dupliquer les données :</div>
          <div class="q-check">
            <input type="checkbox" id="checkform"
                   [(ngModel)]="withTrainer" />
            <label for="checkform">
              <span></span>Dupliquer les formateurs associés aux stages
            </label>
          </div>
          <div class="q-check">
            <input type="checkbox" id="checkresp"
                   [(ngModel)]="withResp" />
            <label for="checkresp">
              <span></span>Dupliquer les responsables associés aux stages
            </label>
          </div>
          <div class="q-check">
            <input type="checkbox" id="checklocation"
                   [(ngModel)]="withLocation" />
            <label for="checklocation">
              <span></span>Dupliquer les lieux associés aux stages
            </label>
          </div>
          <div class="q-check">
            <input type="checkbox" id="checkreserv"
                   [(ngModel)]="withReserv" />
            <label for="checkreserv">
              <span></span>Dupliquer les réservations associées aux stages
            </label>
          </div>
          <div class="q-check">
            <input type="checkbox" id="checktache"
                   [(ngModel)]="withTache" />
            <label for="checktache">
              <span></span>Dupliquer les taches associées aux stages
            </label>
          </div>
        </div>
        <div class="mx-3">
          <div class="q-c-main mb-2">Liste des stages du cursus : </div>
          <div *ngFor="let stage of listStageForCursus">
            <div class="q-check">
              <input type="checkbox" [id]="stage.Value"
                     [ngModel]="stage.Selected" />
              <label [for]="stage.Value">
                <span></span>{{stage.Text}}
              </label>
            </div>
          </div>

        </div>

      </div>

      <button class="q-btn q-main m-3" (click)="onSaveBo()"><i [ngClass]="[isSaving ? 'fas fa-spin fa-spinner fa-pulse' : 'fas fa-save']" class="mr-1"></i>Dupliquer le cursus</button>

      <q-bodisplay *ngIf="boModel"
                   [(save)]="saveBO"
                   [item]="boModel"
                   (sendEvent)="onBoSaved($event)"></q-bodisplay>
    </div>
  </div>
</ng-template>
